import { Link } from "react-router-dom";
import { Badge, DataTable, Select, stamp, useTable } from "./ui";

const target = (r) => {
  if (r.entity_type === "florist" && r.entity_id) return `/admin/florists/${r.entity_id}`;
  if (r.entity_type === "order" && r.entity_id) return `/admin/orders?order=${r.entity_id}`;
  if (r.entity_type === "payment" && r.entity_id) return `/admin/payments?payment=${r.entity_id}`;
  if (r.entity_type === "settings") return "/admin/settings";
  return null;
};

export default function ActivityPage() {
  const table = useTable("/admin/tables/activity");
  const columns = [
    { key: "created_at", label: "When", sortable: true, render: (r) => <span className="text-xs whitespace-nowrap">{stamp(r.created_at)}</span> },
    { key: "actor_email", label: "Who", sortable: true, render: (r) => <span className="text-xs">{r.actor_email}<span className="block text-muted">{r.actor_role}</span></span> },
    { key: "action", label: "Action", sortable: true, render: (r) => <Badge tone="ink">{(r.action || "").replace(/_/g, " ")}</Badge> },
    { key: "entity_type", label: "On", render: (r) => {
      const to = target(r);
      return to ? <Link className="underline decoration-brass underline-offset-2" to={to}>{r.entity_type}</Link> : (r.entity_type || "—");
    } },
    { key: "summary", label: "Detail", render: (r) => <span className="text-xs">{r.summary}</span> },
  ];
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted" data-testid="activity-intro">Every back-office action: suspensions, refunds, payouts, moderation and settings changes.</p>
      <DataTable table={table} columns={columns} testid="activity-table" name="activity"
                 searchPlaceholder="Action, person, detail…" empty="No back-office action recorded yet."
                 filters={<Select testid="activity-filter-entity" placeholder="Anything" value={table.params.entity_type}
                                  onChange={(v) => table.set({ entity_type: v })}
                                  options={["order", "florist", "product", "payment", "settings"]} />} />
    </div>
  );
}
